import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class ActionCollectionsTranslations extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'ActionCollectionsTranslations'
  // Define default properties here
  static instanceDefaults () {
    return {
      title: '',
      description: '',
      localeId: 1,
      actionCollectionId: 1,
    }
  }
}
const servicePath = 'action-collections-translations'
const servicePlugin = makeServicePlugin({
  Model: ActionCollectionsTranslations,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
